<template>
<v-app>
    <Header @getTypeMenu="changeTypeMenu" :table_name="table_name" :table_type="table_type" :table_detail="table_detail" />
    <TakeOut :typeMenu="typeMenuBuffet" />
    <Footer :table_type="table_type" />
</v-app>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import Header from '@/components/menuuser/Header.vue'
import TakeOut from '@/components/menuuser/TakeOut.vue'
import Footer from '@/components/menuuser/Footer.vue'
export default {
    name: 'takeOutUserTable',
    components: {
        Header,
        TakeOut,
        Footer,
    },
    data() {
        return {
            typeMenuBuffet: '',
            table_name: '',
            table_type: '',
            table_detail: '',
        }
    },
    methods: {
        async changeTypeMenu(typeMenu) {
            this.typeMenuBuffet = typeMenu
        },
        async tableDetail() {
            HTTP.get(`/customer/open-buffet/` + this.$store.state.cartTakeOutTableId + `/` + this.$route.params.pre_order + `?store_id=${this.$route.query.store_id}&token=`+this.$route.params.token, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.table_name = response.data.opentable_detail.name
                        this.table_type = response.data.opentable_detail.type
                        this.table_detail = response.data.opentable_detail.detail
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                    if (error.response.status === 500) {
                        // this.$router.push('/thankyouuser')
                    }

                })
        }
    },
    created() {
        HTTP.get(`/POS/table/check_token_opentable/` + this.$store.state.cartTakeOutTableId + `/` + this.$route.params.token + `/` + this.$route.params.pre_order, {
                headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                }
            })
            .then((response) => {
                if (response.data.successful === false) {
                    this.$store.commit('clearCartListUser')
                    this.$store.commit('clearCartTakeOutTableListUser')
                    this.$store.commit('clearCartListUserTakeOut')
                    this.$store.commit('clearCartOrderOnlineUser')
                    this.$router.push('/thankyouuser')
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
                if (error.response.status === 500) {
                    this.$store.commit('clearCartListUser')
                    this.$store.commit('clearCartTakeOutTableListUser')
                    this.$store.commit('clearCartListUserTakeOut')
                    this.$store.commit('clearCartOrderOnlineUser')
                    this.$router.push('/thankyouuser')
                }

            })
    },
    mounted() {
        this.tableDetail()
    }
}
</script>
